module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_05.5a73370c.png";